import useLoginTypes from "./login";

const useStrings = () => {
    return {
        useLoginTypes
    };
}

export default useStrings;